/**
 * Channels contains definition of all available communication channels.
 * @const channels
 */
/*
    Can be used like: channels.legacy.oddStyle.all
*/
export const channels = {
    legacy: {
        all: "legacy.*",
        oddStyle: {
            all: "legacy.oddStyle.*",
            update: "legacy.oddStyle.update",
            request: "legacy.oddStyle.request"
        },
        timeZone: {
            all: "legacy.timeZone.*",
            update: "legacy.timeZone.update",
            request: "legacy.timeZone.request"
        },
        eventView: {
            all: "legacy.eventView.*",
            yourBetSwitch: "legacy.eventView.yourBetSwitch",
            event: {
                all: "legacy.eventView.event.*",
                update: "legacy.eventView.event.update"
            }
        },
        tabSwitcher: {
            all: "legacy.tabSwitcher.*",
            goToNextTab: "legacy.tabSwitcher.goToNextTab",
            showHideTab: "legacy.tabSwitcher.showHideTab"
        },
        betslip: {
            all: "legacy.betslip.*",
            items: {
                all: "legacy.betslip.items.*",
                add: "legacy.betslip.items.add",
                remove: "legacy.betslip.items.remove",
                update: "legacy.betslip.items.update"
            }
        },
        userInfo: {
            all: "legacy.userInfo.*",
            onLogin: "legacy.userInfo.onLogin",
            onLogout: "legacy.userInfo.onLogout",
            onGetBalance: "legacy.userInfo.onGetBalance",
            onAcceptOddsChanged: "legacy.userInfo.onAcceptOddsChanged",
            requestBalanceUpdate: "legacy.userInfo.requestBalanceUpdate",
            request: "legacy.userInfo.request"
        },
        platformJWTChange: {
            all: "legacy.platformJWTChange.*",
            renewJWTToken: "legacy.platformJWTChange.renewJWTToken"
        },
        anonymousJWTChange: {
            all: "legacy.anonymousJWTChange.*",
            renewJWTToken: "legacy.anonymousJWTChange.renewJWTToken"
        },
        activeEvent: {
            all: "legacy.activeEvent.*",
            init: "legacy.activeEvent.init",
            update: "legacy.activeEvent.update",
            updateLast: "legacy.activeEvent.updateLast"
        },
        sport: {
            all: "legacy.sport.*",
            update: "legacy.sport.update"
        },
        application: {
            all: "legacy.application.*",
            request: "legacy.application.request",
            init: "legacy.application.init",
            seamless: {
                all: "legacy.application.seamless.*",
                isIframeHeightControlled: "legacy.application.seamless.isIframeHeightControlled"
            }
        },
        liveStream: {
            all: "legacy.liveStream.*",
            update: "legacy.liveStream.update"
        },
        eventCard: {
            all: "legacy.eventCard.*",
            changedToSide: "legacy.eventCard.changedToSide"
        },
        filter: {
            all: "legacy.filter.*",
            events: {
                all: "legacy.filter.events.*",
                none: "legacy.filter.events.none",
                liveStream: "legacy.filter.events.liveStream",
                fastMaskets: "legacy.filter.events.fastMaskets"
            }
        },
        openBets: {
            all: "legacy.openBets.*",
            toggleBetPlacement: "legacy.openBets.toggleBetPlacement",
            requestStatus: "legacy.openBets.requestStatus"
        },
        event: {
            all: "legacy.event.*",
            request: "legacy.event.request",
            update: "legacy.event.update",
            data: {
                pull: "legacy.event.data.pull",
                push: "legacy.event.data.push"
            }
        }
    },
    eventsFilter: {
        all: "eventsFilter.*",
        allSports: "eventsFilter.allSports",
        sports: "eventsFilter.sports",
        leagues: "eventsFilter.leagues",
        dates: "eventsFilter.dates",
        liveStream: "eventsFilter.liveStream",
        favorites: "eventsFilter.favorites",
        regions: "eventsFilter.regions",
        marketGroups: "eventsFilter.marketGroups"
    },
    authorization: {
        all: "authorization.*",
        renewJWTToken: "authorization.renewJWTToken"
    },
    eventsList: {
        all: "eventsList.*",
        tags: "eventsList.tags",
        count: "eventsList.count"
    },
    favoriteEvents: {
        all: "favoriteEvents.*",
        add: "favoriteEvents.add",
        remove: "favoriteEvents.remove"
    },
    aggregatedEvents: {
        all: "aggregatedEvents.*",
        retrieval: {
            all: "aggregatedEvents.retrieval.*",
            activate: "aggregatedEvents.retrieval.activate",
            deactivate: "aggregatedEvents.retrieval.deactivate",
        },
        incident: {
            all: "aggregatedEvents.incident.*",
            update: "aggregatedEvents.incident.update",
            request: "aggregatedEvents.incident.request"
        },
        games: {
            all: "aggregatedEvents.games.*",
            update: "aggregatedEvents.games.update",
            request: "aggregatedEvents.games.request"
        },
        scores: {
            all: "aggregatedEvents.scores.*",
            update: "aggregatedEvents.scores.update",
            request: "aggregatedEvents.scores.request"
        },
        currentId: {
            all: "aggregatedEvents.currentId.*",
            update: "aggregatedEvents.currentId.update",
            request: "aggregatedEvents.currentId.request"
        },
        generalInfo: {
            all: "aggregatedEvents.generalInfo.*",
            update: "aggregatedEvents.generalInfo.update",
            request: "aggregatedEvents.generalInfo.request"
        },
        participants: {
            all: "aggregatedEvents.participants.*",
            update: "aggregatedEvents.participants.update",
            request: "aggregatedEvents.participants.request"
        },
        ids: {
            all: "aggregatedEvents.ids.*",
            update: "aggregatedEvents.ids.update",
            request: "aggregatedEvents.ids.request"
        }
    },
    breedFilter: {
        all: "breedFilter.*",
        center: {
            all: "breedFilter.center.*",
            update: "breedFilter.center.update",
            request: "breedFilter.center.request"
        },
        side: {
            all: "breedFilter.side.*",
            update: "breedFilter.side.update",
            request: "breedFilter.side.request"
        },
    },
    toteRaceEventView: {
        all: "toteRaceEventView.*",
        update: "toteRaceEventView.update",
        request: "toteRaceEventView.request"
    },
    toteBetAssembler: {
        all: "toteBetAssembler.*",
        stake: "toteBetAssembler.stake",
        calculateRequest: "toteBetAssembler.calculateRequest",
        raceInfo: "toteBetAssembler.raceInfo",
        onAddBet: "toteBetAssembler.onAddBet"
    },
    totePopups: {
        onDisplayLoginForm: "totePopups.onDisplayLoginForm",
    },
    toteSEO: {
        all: "toteSEO.*",
        init: "toteSEO.init",
        buildURL: {
            request: "toteSEO.buildURL.request"
        },
        parseURL: {
            request: "toteSEO.parseURL.request"
        },
    },
    toteData: {
        eventParser: {
            request: "toteData.eventParser.request"
        },
        leagueParser: {
            request: "toteData.leagueParser.request"
        },
        regionParser: {
            request: "toteData.regionParser.request"
        }
    },
    iPadSettingsController: {
        onFirstLogin: "iPadSettingsContoller.onFirstLogin"
    },
    realityCheck: {
        all: "realityCheck.*",
        show: "realityCheck.show",
        onShow: "realityCheck.onShow",
        onClose: "realityCheck.onClose",
        isShowEnabled: "realityCheck.isShowEnabled"
    },
    playerProps: {
        all: "playerProps.*",
        request: "playerProps.request",
        update: "playerProps.update"
    }
};
//# sourceMappingURL=channels.js.map